// react
import React from "react";
// loading
import Loading from "../../../components/childrens/loading/loading.tsx";
// feature
import { splitNumber } from "../../../features/splitNumber/splitNumber.tsx";
// controller
import useGetData from "../../../hook/getData.tsx";
// query
import { GetOrders } from "../../../services/agent/orders/getOrders.tsx";

const Orders = () => {
    const { data, isLoading } = useGetData(['orders'], GetOrders);
    console.log(data)
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>لیست  سفارشات</p>
                        <div className={'card card-body shadow border-0'}>
                            {!isLoading ? (
                                <>
                                    <div className="table-responsive">
                                        <table className="table text-center align-middle font-medium">
                                            <thead>
                                                <tr>
                                                    <th>ردیف</th>
                                                    <th>نام سفارش</th>
                                                    <th>کدپیگیری</th>
                                                    <th>پلن</th>
                                                    <th>تاریخ</th>
                                                    <th>وضعیت</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.orders?.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.order_name}</td>
                                                        <td>{item.order_code}</td>
                                                        <td>{item.plan_id}</td>
                                                        <td>{item.time}</td>
                                                        <td>
                                                            {item.status === 0 ?
                                                                (
                                                                    <>
                                                                        <button className="btn btn-danger">
                                                                            پرداخت نشده
                                                                        </button>
                                                                    </>

                                                                )
                                                                :
                                                                (
                                                                    <>
                                                                        <button className="btn btn-sucess">
                                                                            پرداخت شده
                                                                        </button>
                                                                    </>
                                                                )
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )
                                :
                                (
                                    <>
                                        <Loading />
                                    </>
                                )
                            }

                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default Orders;